import { STATE_CACHE_NAME } from '@common/Core/constants/cache';
import { FAVORITE_PRODUCTS_SESSION_CACHE_NAME } from '@common/Favorites/constants/cache';
import { RECENTS_SESSION_CACHE_NAME } from '@common/Recents/constants/cache';
import { remove as removeFromLocalStorage } from './localStorage';
import { removeSession as removeFromSessionStorage } from './sessionStorage';

export const clearCachedData = () => {
    removeFromSessionStorage(FAVORITE_PRODUCTS_SESSION_CACHE_NAME);
    removeFromSessionStorage(RECENTS_SESSION_CACHE_NAME);
    removeFromLocalStorage(STATE_CACHE_NAME);
};
